<template>
  <card-item card="item_work" :tabs="tabs" :activeTab="activeTab" :id="id" />
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
        {
          title: "Вопросы",
          component: () => import("./WorkQuestion"),
                            key:'questions',
        },

      ],
      activeTab: 0,
    };
  },
};
</script>